import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseDialogComponent } from './base-dialog.component';
import { AngularSvgIconModule } from 'angular-svg-icon';

@NgModule({
  declarations: [
    BaseDialogComponent,
  ],
  imports: [
    CommonModule,
    AngularSvgIconModule,
  ],
  exports: [
    BaseDialogComponent,
  ]
})
export class BaseDialogModule { }
